import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'

import {trans} from '@utils'

import Statistic from "../Statistic"
import {getSuitableData} from "../../utility/utils"

const StatisticTotalInspections = props => {
  const {
    initOnMount = false,
    uri = null,
    withChart = true,
    chartType = 'area',
    vertical = false,
    height = 100,
    skeletonMinHeight
  } = props
  const {value, loading, stats} = useSelector(store => _.get(store, 'analytics.data.statistics_total_inspections'))

  const dispatch = useDispatch()

  useEffect(() => {
    if (initOnMount) {
      // _getTotalInspections(uri)
    }
    return () => {
      // dispatch({
      //   type: 'ANALYTICS_CHARTS_DATA',
      //   payload: {
      //     total_inspections: {
      //       value: 0,
      //       loading: true,
      //       stats: []
      //     }
      //   }
      // })
    }
  }, [])

  const options = {
    tooltip: {
      y: {
        formatter (y) {
          return y.toFixed(0)
        },
        title: {
          formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
            return ''
          }
        }
      }
    }
  }

  return (
    <Statistic
      title={trans('analytics.actions.inspections')}
      color={'warning'}
      data={stats}
      stats={value}
      // icon={<User />}
      withChart={withChart}
      chartType={chartType}
      vertical={vertical}
      loading={loading}
      height={height}
      skeletonMinHeight={skeletonMinHeight}
      options={options}
    />
  )
}

StatisticTotalInspections.propTypes = {}

export default StatisticTotalInspections
